export default function copyToClipboard(text, onCopy) {
  // Create temporary textarea and paste text into
  const textField = document.createElement('textarea');
  textField.innerText = text;
  document.body.appendChild(textField);

  // Select text and copy
  textField.select();
  document.execCommand('copy');

  // Remove textarea and call onCopy callback
  textField.remove();
  onCopy();
}



// WEBPACK FOOTER //
// ./src/utils/copyToClipboard.js